// Deprecated - Use Timer instead

export class TimeUtil {
    public static sleep(millis: number): Promise<void> {
        return new Promise<void>(resolve => {
            setTimeout(resolve, millis);
        });
    }

    public static getTimeFrameBetweenMinutes(minutes: number): string {
        let timeString;
        if (minutes < 15) {
            timeString = '15 mins';
        } else if (minutes >= 15 && minutes < 30) {
            timeString = '30 mins';
        } else if (minutes >= 30  && minutes < 60) {
            timeString = '60 mins';
        } else if (minutes >= 60 && minutes < 120) {
            timeString = '2 hours';
        } else if (minutes >= 120 && minutes < 720) {
            timeString = '12 hours';
        } else if (minutes >= 720 && minutes < 1440) {
            timeString = '24 hours';
        } else if (minutes >= 1440 && minutes < 4320) {
            timeString = '3 days';
        } else if (minutes >= 4320 && minutes < 10080) {
            timeString = '7 days';
        } else if (minutes >= 10080 && minutes < 21600) {
            timeString = '15 days';
        } else if (minutes >= 21600 && minutes < 43200) {
            timeString = '30 days';
        } else if (minutes >= 43200 && minutes < 86400) {
            timeString = '60 days';
        } else if (minutes >= 86400 && minutes < 172800) {
            timeString = '120 days';
        } else {
            return 'More than or equal to 120 days';
        }
        return `Less than ${timeString}`;
    }
}
